/*
 *  -----------------------------------------------------------------------
 *    <copyright file="import-study-error/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';
import React from 'react';
import { useTranslation } from 'hooks';
import Button from 'views/components/core/buttons';
import { CustomDialog, DialogActions, DialogTitle } from 'views/components/core/dialog';

const ImportStudyError = ({ open, onClose }: { open: boolean; onClose: Function }) => {
    const { t } = useTranslation();

    const close = () => {
        onClose();
    };

    return (
        <CustomDialog onClose={close} fullWidth maxWidth="md" scroll="paper" open={open} className="custom-width-popup">
            <DialogTitle id="import-study-error-modal-title">
                {t('admin:importStudy')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={close}
                    data-testid="close-dialog"
                />
            </DialogTitle>
            <DialogContent className="add-treatment-dialog-content" style={{ padding: '15px' }}>
                <div className="export-study-text">{t('admin:importStudyError')}</div>
                <DialogActions className="flex-end">
                    <Button id="import-error-study-btn" text="close" onClick={close} />
                </DialogActions>
            </DialogContent>
        </CustomDialog>
    );
};

export default ImportStudyError;
